<template>
    <div v-if="showEmpty">
        <NavBar />
        <ProjectList showDrawer="true"/>
        <main>
            <v-row class="map_edit_container">
                <v-col class="mb-30" cols="12">
                    <ProjectEmpty />
                </v-col>
            </v-row>
        </main>
    </div>
</template>

<script>
import NavBar       from "../NavBar";
import ProjectList  from "../PLComponents/ProjectList";
import ProjectEmpty  from "../PLComponents/ProjectEmpty";

export default {
    name: "ProjectsList",
    components:{
        NavBar,
        ProjectList,
        ProjectEmpty
    },
    data () {
        return {
            showEmpty: false
        }
    },
    computed: {
        projects () {
            return this.$store.getters.projects;
        },
        projectsLoaded(){
            return this.$store.getters.projectsLoaded
        }
    },
    watch: {
        projects: function (){
            if (this.projectsLoaded && this.projects.length != 0){
                this.$router.push('/projects/' + this.projects[0].hashid)
                .catch(() => {});
            }
        }
    },
    created() {
        this.$vuetify.theme.dark = true;
        if (!this.projectsLoaded){
            this.$store.dispatch('getProjects')
            .then(() => {
                if(this.projects.length == 0){
                    this.showEmpty = true;
                }
                else{
                    this.$router.push('/projects/' + this.projects[0].hashid);
                }
            })
            .catch(() => {})
        }
        else{
            if(this.projects.length == 0){
                this.showEmpty = true;
            }
            else{
                this.$router.push('/projects/' + this.projects[0].hashid);
            }
        }
    }
};
</script>
